import { Box, styled } from '@mui/material';

const Statistic = styled(Box)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1)
}));

export default Statistic;